/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_ScoringInputs */

const en_directory_hubs_signals_ai_scoring = /** @type {(inputs: Directory_Hubs_Signals_Ai_ScoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggregated from the Seek AI agent-readiness benchmark: six dimensions and twenty-one automated checks (docs, quickstart, OpenAPI, MCP, CLI, structured output, and more), each verified against public documentation — never vendor claims. A published audit drives the score; products without one show a clearly labeled preview.`)
};

const zh_directory_hubs_signals_ai_scoring = /** @type {(inputs: Directory_Hubs_Signals_Ai_ScoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由 Seek AI agent-readiness 基准聚合：六个维度、二十一项自动化检查（文档、快速上手、OpenAPI、MCP、CLI、结构化输出等），逐项对照公开文档验证——绝不采信厂商声明。有已发布审计的产品按审计计分；没有的显示明确标注的预览分。`)
};

/**
* | output |
* | --- |
* | "Aggregated from the Seek AI agent-readiness benchmark: six dimensions and twenty-one automated checks (docs, quickstart, OpenAPI, MCP, CLI, structured output..." |
*
* @param {Directory_Hubs_Signals_Ai_ScoringInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_scoring = /** @type {((inputs?: Directory_Hubs_Signals_Ai_ScoringInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_ScoringInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_scoring(inputs)
	return zh_directory_hubs_signals_ai_scoring(inputs)
});
export { directory_hubs_signals_ai_scoring as "directory.hubs.signals.ai.scoring" }